import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "cleaning_services",
    title: "Thorough Cleaning",
    description:
      "We handle tough tasks, from dust and debris removal to detailed cleaning of every surface.",
  },
  {
    icon: "verified",
    title: "Professional Results",
    description:
      "We ensure your space is clean, polished, and ready for handover or occupancy after construction.",
  },
  {
    icon: "health_and_safety",
    title: "Safe & Efficient",
    description:
      "Our trained cleaners use specialised tools and techniques to handle post-construction mess effectively.",
  },
  {
    icon: "tune",
    title: "Tailored Solutions",
    description:
      "Adapted to your property size and the specific requirements of the build or renovation.",
  },
];

function PostConstruction_Section1() {
  return <ServiceHighlights title="Why Choose Our Post-Construction Cleaning?" items={items} />;
}

export default PostConstruction_Section1;
